<template>
  <PrimeDataTable
    :title="'Stage'"
    :showFilter="true"
    :searchOption="true"
    :selectAll="true"
    :showDownload="true"
    :showUpload="true"
    :showAdd="true"
    :columnData="columns"
    :data="data"
    @addDiolog="addDiolog()"
    @rowAction="rowActions($event)"
    activity="stage"
  />

  <v-dialog persistent v-model="dialog" width="600px">
    <CreateStage
      @closeDialog="close()"
      @reload="getStage()"
      :id="editId"
      :viewType="viewType"
    />
  </v-dialog>
</template>

<script>
import CreateStage from "./CreateStage.vue";
import PrimeDataTable from "@/components/PrimeDataTable";
import StageService from "@/api/service/Stage/StageService";
// import commonService from "@/common.service";
export default {
  components: {
    CreateStage,
    PrimeDataTable,
  },
  data() {
    return {
      data: [],
      columns: [],
      date: new Date(),
      editId: null,
      dialog: false,
      viewType: false,
    };
  },
  created() {
    this.loadColumns();
    this.download = true;
    this.search = true;
    this.checkbox = true;
    this.getStage();
  },
  methods: {
    loadColumns() {
      this.columns = [
        {
          field: "code",
          header: "Code",
          style: { width: "100px", color: "" },
          toolTip: "code",
          sortfield: true,
        },
        {
          field: "name",
          header: "Name",
          style: { width: "100px", color: "" },
          toolTip: "name",
          sortfield: true,
        },
        {
          field: 'sequence',
          header: "Sequence ",
          style: { width: "100px", color: "" },
          toolTip: "sequence",
          sortfield: true,
        },
        {
          field: "modified",
          header: "Modified",
          style: { width: "100px", color: "" },
          toolTip: "modified",
          sortfield: true,
        },
        {
          field: "active",
          header: "Status",
          style: { width: "100px", color: "" },
          toolTip: "active",
          sortfield: true,
        },
        {
          field: "action",
          header: "Action",
          style: { width: "100px", color: "" },
          toolTip: "Action",
          sortfield: true,
          rowActions: [{ action: "view" }, { action: "edit" }],
        },
      ];
    },

    close() {
      this.dialog = false;
    },
    rowActions($event) {
      if ($event.type == "view") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = $event.type;
      }
      if ($event.type == "edit") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = $event.type;
      }
      if ($event.type == "select") {
        this.dialog = true;
        this.editId = $event.data.id;
        this.viewType = "view";
      }
    },
    async getStage() {
      let res = await StageService.findAll();
      this.data = res;
      console.log(this.data , 'stage is coming' )
    },
    addDiolog() {
      this.viewType = null;
      this.dialog = true;
      this.editId = null;
      this.viewType = "Add";
    },
  },
};
</script>
